import { useEffect } from "react";
import Head from "next/head";
import Image from "next/image";

import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import MainHeader from "../components/MainHeader";
import MainFooter from "../components/MainFooter";

import { getCookie } from "cookies-next";

import fonts from "../styles/FontInter.module.css";
import mainTheme from "../components/mainTheme";
import styles from "../styles/Home.module.css";

export default function TemplatePage({ utm }) {
  useEffect(() => {
    dataLayer.push({ event: "optimize.activate" });
  }, []);

  return (
    <ThemeProvider theme={mainTheme}>
      <Head>
        <title>Our DMCA Notice - Elm Street</title>
        <meta name="description" content="Our DMCA Notice - Elm Street" />
        <link rel="icon" href="/favicon.ico" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@weareelmstreet" />
        <meta name="twitter:creator" content="@weareelmstreet" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://elmstreet.com/dmca" />
        <meta property="og:title" content="Our DMCA Notice - Elm Street" />
        <meta property="og:description" content="Our DMCA Notice - Elm Street" />
        <meta property="og:image" content="https://elmstreet.com/og_images/elmstreetog.jpg" />
      </Head>
      <CssBaseline className={fonts} />
      <MainHeader />

      <Container maxWidth="lg" style={{ paddingLeft: "20px", paddingRight: "20px" }}>
        <div style={{ marginTop: "55px", marginBottom: "55px" }}>
          <Grid container spacing={8}>
            <Grid item md={12} sm={12}>
              <Typography variant="h2" component="h2">
                dmca <span style={{ color: "#f69c26" }}>notice</span>
              </Typography>
              <br />
              <Typography variant="h5" component="h5">
                Claims of Copyright Infringement and Related Issues
              </Typography>
              We respect the intellectual property rights of others. Anyone who believes their work has been reproduced
              in a way that constitutes copyright infringement may notify our agent by providing the following
              information:
              <br />
              <br />
              1. Identification of the copyrighted work that you claim has been infringed, or, if multiple copyrighted
              works at a single online site are covered by a single notification, a representative list of such works at
              the site;
              <br />
              2. Identification of the material that you claim is infringing and needs to be removed, including a
              description of where it is located so that the copyright agent can locate it;
              <br />
              3. Your address, telephone number, and, if available, e-mail address, so that the copyright agent may
              contact you about your complaint;
              <br />
              4. A signed statement that the above information is accurate; that you have a good faith belief that the
              identified use of the material is not authorized by the copyright owner, its agents, or the law; and,
              under penalty of perjury, that you are the copyright owner or are authorized to act on the copyright
              owner’s behalf in this situation.
              <br />
              Upon obtaining such knowledge we will act expeditiously to remove, or disable access to, the material.
              Please be aware that there are substantial penalties for false claims.
              <br />
              If a notice of copyright infringement has been wrongly filed against you, you may submit a counter
              notification to our agent. A valid counter notification is written communication that incorporates the
              following elements:
              <br />
              1. A physical or electronic signature of the poster;
              <br />
              2. Identification of the material that has been removed or to which access has been disabled and the
              location at which the material appeared before it was removed or access to it was disabled;
              <br />
              3. A statement under penalty of perjury that you have a good faith belief that the material was removed or
              disabled as a result of mistake or misidentification;
              <br />
              4. Your name, address, and telephone number; a statement that you consent to the jurisdiction of federal
              district court for the judicial district in which your address is located, or if your address is located
              outside of the U.S., for any judicial district in which the service provider may be found; and that you
              will accept service of process from the complainant.
              <br />
              <br />
              Notices of the foregoing copyright issues should be sent as follows:
              <br />
              <br />
              <Typography variant="h5" component="h5">
                By mail:
              </Typography>
              Copyright Compliance Office 10601 Clarence Drive Suite 265 Frisco, TX 75033
              <br />
              <br />
              <Typography variant="h5" component="h5">
                Phone:
              </Typography>
              336-722-3456
              <br />
              <br />
              <Typography variant="h5" component="h5">
                Fax:
              </Typography>
              336-723-7464
              <br />
              <br />
              <Typography variant="h5" component="h5">
                By e-mail:
              </Typography>
              <span style={{ fontSize: "12px" }}>copyrightcompliance@elmstreettechnology.com</span>
              <br />
              <br />
              If you give notice of copyright infringement by e-mail, an agent may begin investigating the alleged
              copyright infringement; however, we must receive your signed statement by mail or as an attachment to your
              e-mail before we are required to take any action. In addition, if you believe in good faith that a notice
              of copyright infringement has been wrongly filed against you, the DMCA permits you to send us
              counter-notice. Notices and counter-notices must meet statutory requirements imposed by the DMCA. You
              acknowledge that if you fail to comply with all of the notice requirements of the DMCA, your notice may
              not be valid. One place to find more information is the U.S. Copyright Office Web site, currently located
              at http://www.copyright.gov. This information should not be construed as legal advice. We recommend you
              seek independent legal counsel before filing a notification or counter-notification. For further
              information about the DMCA, please visit the website of the United States Copyright Office at:
              http://www.copyright.gov. Please note: If you materially misrepresent that online material, product, or
              activity is infringing your copyrights, you may be liable for damages (including court costs and
              attorneys' fees) and could be subject to criminal prosecution for perjury. We suggest that you consult
              your legal advisor before filing a notice or counter-notice.
              <br />
              <br />
              <Typography variant="h5" component="h5">
                Termination
              </Typography>
              You may stop using the Site at any time. Elm Street Technology, LLC may suspend or terminate the Site at
              any time at Elm Street Technology, LLC's discretion and without notice. Elm Street Technology, LLC may
              also terminate, limit or suspend your access to the Site for any reason at any time and without notice.
              For example, Elm Street Technology, LLC may terminate your access to this Site if you are not complying
              with these Terms or if Elm Street Technology, LLC determines that you are a repeat infringer of
              third-party intellectual property rights.
            </Grid>
          </Grid>
        </div>
      </Container>

      <MainFooter />
    </ThemeProvider>
  );
}

export const getServerSideProps = ({ req, res }) => {
  let cookies = getCookie("elmlead", { req, res });
  if (cookies) {
    return { props: { utm: cookies } };
  }
  return { props: {} };
};
